import React, { useState, useEffect } from 'react';
import Shared from 'screens/shared';
import { Paper, Collapse } from '@mui/material';
import { useSelector } from 'react-redux';
import { actions } from 'redux/local';
import { _t } from 'utils';
import { ROUTE } from 'constant';

export default () => {
  const [openCreateForm, setOpenCreateForm] = useState(false);
  const [items, setItems] = useState([]);

  const { sshKeys = [] } = useSelector((e) => e);

  useEffect(() => {
    setItems(sshKeys);
  }, [sshKeys]);

  useEffect(() => {
    actions.common.setLayoutTitle({ layout: { title: _t('SSH Keys'), menu: ROUTE.DASHBOARD.SSH_KEYS.key } });
    actions.sshKey.getAll();
  }, []);

  const sshKey = {
    name: '',
    key: '',
    defaultKey: false,
  };

  const sshKeysFields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'key',
      type: 'textarea',
      title: _t('SSH Key'),
    },
    {
      name: 'defaultKey',
      type: 'switch',
      title: _t('Is Default Key'),
    },
  ];

  const onAdd = () => { };
  const onEdit = () => { };
  const selectToEdit = () => { };
  const selectToDelete = () => { };
  const deselectToEdit = () => { };

  const onSave = ({ id = null, ...item }) => {
    if (id) {
      return onEdit({ ...item, id });
    }
    onAdd(item);
    return setOpenCreateForm(false);
  };

  return (
    <div className="screen-ssh-key screen-common">
      <h3 className="screen-common-title">
        {_t('List')}
        {' '}
        <span className="button" onClick={() => setOpenCreateForm((s) => !s)}>
          <Shared.widgets.Icon name="plus" />
          {_t('Add')}
        </span>
      </h3>
      <Collapse in={openCreateForm} collapsedSize="0px">
        <Paper style={{ marginTop: 20 }}>
          {openCreateForm && (
            <Shared.forms.Form
              fields={sshKeysFields}
              fieldsValues={sshKey}
              onSubmit={onSave}
              onCancel={() => setOpenCreateForm(false)}
            />
          )}
        </Paper>
      </Collapse>
      <div className="cards">
        {items.map((keyInner) => {
          const {
            id, name, defaultKey, isEdit = false,
          } = keyInner;
          return (
            <div key={id}>
              <Collapse in={isEdit} collapsedSize="0px">
                <Paper style={{ marginTop: 20 }}>
                  {isEdit && (
                    <Shared.forms.Form
                      fields={sshKeysFields}
                      fieldsValues={keyInner}
                      onSubmit={onSave}
                      onCancel={() => deselectToEdit(id)}
                    />
                  )}
                </Paper>
              </Collapse>
              {!isEdit && (
                <Shared.widgets.Card key={id}>
                  <div className="cards-left">
                    <div className="cards-left-logo">
                      <Shared.widgets.Icon name="key" />
                    </div>
                  </div>

                  <div className="cards-right">
                    <span className="cards-right-title">{name}</span>

                    <div className="cards-right-props">
                      <div>
                        <span>
                          {_t('Default:')}
                          {` ${defaultKey ? _t('Yes') : _t('No')}`}
                        </span>
                      </div>

                    </div>
                  </div>

                  <div className="cards-buttons">
                    <Shared.widgets.Icon name="edit" onClick={() => selectToEdit(id)} />
                    <Shared.widgets.Icon name="trash" onClick={() => selectToDelete(id)} />
                  </div>
                </Shared.widgets.Card>
              )}
            </div>
          );
        }).reverse()}
      </div>
    </div>
  );
};
